import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { formatTime } from "../utils/timeFormatter.js";
import wordsprintwhite from '../pics/wordsprintwhite.png';
import { paragraphs } from "./paragraphs.ts";
import { getResults } from "../utils/getResults.js";
// import randomWords from "random-words";

const Practice = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const { seconds = 10, highlightCurrentWord, highlightMistakes, clearInput } = location.state || {};
  const [timeLeft, setTimeLeft] = useState(seconds);
  const [isStarted, setIsStarted] = useState(false);
  const [isRunning, setIsRunning] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [randomText, setRandomText] = useState("");
  const [input, setInput] = useState("");
  const [results, setResults] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [clearOnSpace, setClearOnSpace] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [typedWords, setTypedWords] = useState([]); // stores what user typed per word

  const [viewSideBySide, setViewSideBySide] = useState(true);

  const [textSize, setTextSize] = useState("sm");

  // setting 
  const [highlightCurrWord, SetHighlightCurrWord] = useState(highlightCurrentWord);
  const [highlightMistake, SetHighlightMistake] = useState(highlightMistakes);
  const [disableBackspace, setDisableBackspace] = useState(true);
  
  
  useEffect(() => {
    generateRandomPara();
    if (highlightCurrWord || highlightMistake) {
      setClearOnSpace(true);
    }
  }, []);

  const generateRandomPara = () => {
    const text = Array.from({ length: 50 }, () => paragraphs[Math.floor(Math.random() * paragraphs.length)]).join(" ");
    setRandomText(text);
  }

  useEffect(() => {
    const startHandler = () => { startTest(); window.removeEventListener("click", startHandler); window.removeEventListener("keydown", startHandler) };
    window.addEventListener("click", startHandler); window.addEventListener("keydown", startHandler);
    return () => { window.removeEventListener("click", startHandler); window.removeEventListener("keydown", startHandler) };
  }, []);

  useEffect(() => {
    if (isRunning && timeLeft > 0) { const t = setInterval(() => setTimeLeft(p => p - 1), 1000); return () => clearInterval(t) }
    else if (isRunning && timeLeft === 0) { setIsStarted(false); finishTest() }
  }, [isRunning, timeLeft]);

  const startTest = () => {
    setIsFinished(false); setInput(""); setTimeLeft(seconds); setIsStarted(true); setIsRunning(true); setResults(null);
  };

  const finishTest = () => {
    setIsRunning(false); setIsFinished(true);
    const actualWords = randomText.split(/\s+/); const userWords = input.trim().split(/\s+/);

    if (highlightCurrWord || highlightMistake) {
      const res = getResults(typedWords, actualWords, seconds);
      setResults(res);
      
      setInput(typedWords.join(" "))
    } else {
      let a = [];
      for (let i = 0; i < userWords.length; i++) {
        a.push(actualWords[i]);
      }
      const res = getResults(userWords, actualWords, seconds);
      setResults(res);
    }

  };

    const home = () => {
    navigate("/");
  };


  const handleInput = (e) => {

    const natEv = e.nativeEvent;
    const inputType = natEv.inputType;
    const value = e.target.value;

    if (!highlightCurrWord && !highlightMistake && disableBackspace && input.endsWith(" ") && inputType == "deleteContentBackward") {
      e.preventDefault();
      return;
    }
    // console.log("event, ", e);

    if (inputType != "insertLineBreak") {
      if (highlightCurrWord || highlightMistake) {

        const currentWord = value.trim().split(/\s+/).pop(); // last word typed

        if (currentWord && currentWord != '') {
          setInput(value);

          // check if user hit space -> submit word
          if (value.endsWith(" ")) {
            const updated = [...typedWords];
            updated[currentIndex] = currentWord;
            setTypedWords(updated);
            setCurrentIndex(currentIndex + 1);
            if (clearOnSpace) setInput("");
          }
        } else {
          e.preventDefault();
        }
      } else {

        setInput(value);

        if (clearOnSpace && value.endsWith(" ")) {
          // const words = randomText.split(" ");
          // const userWord = value.trim();
          // const currentIndex = input.trim().split(/\s+/).length - 1;
          setInput("");
        }
      }
    } else {
      e.preventDefault();
    }
  };


  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  const getHighlightedText = () => {
    const words = randomText.split(" ");
    return words.map((word, i) => {
      let className = "";
      if (i === currentIndex && highlightCurrWord) {
        className = "bg-yellow-200 dark:bg-yellow-700"; // current word
      }
      if (typedWords[i] && typedWords[i] !== word && highlightMistake) {
        className = "bg-red-200 dark:bg-red-700"; // mistake
      }
      return `<span class="${className}">${word}</span>`;
    }).join(" ");
  };

  return <div className="min-h-screen flex flex-col font-jarkarta dark:bg-gray-950">

    {/* Top bar */}
    <div className="flex justify-between items-center bg-gray-950 px-3 py-1">
      <div className="flex items-center gap-1">
        <img src={wordsprintwhite} className="w-2 h-4" alt="favicon" />
        <span className="text-gray-50 text-xs tracking-wider font-dmserif">Word Sprint</span>
      </div>
      <div className="flex gap-1">
        <button onClick={home} className="text-gray-200 text-xs border border-gray-500 rounded px-1 py-0.5 hover:font-semibold">
          Home
        </button>
        <select onChange={(event)=> setTextSize(event.target.value)} className="text-gray-200 bg-gray-950 text-xs border rounded px-1 hover:font-semibold">
          <option value="xs">xs</option>
          <option value="sm">sm</option>
          <option value="md">md</option>
          <option value="lg">lg</option>
          <option value="xl">xl</option>
          <option value="2xl">2xl</option>
        </select>
        <button onClick={toggleFullscreen} className="text-gray-200 text-xs border rounded px-1 py-0.5 hover:font-semibold">
          {isFullscreen ? "Exit Fullscreen" : "Fullscreen"}
        </button>
      </div>

    </div>

    <div className="flex px-3 flex-row items-center justify-between text-center gap-1 mt-1 leading-none">
      <div className="w-1/4">
        <button onClick={finishTest}
          className={`${!isRunning ? 'invisible' : ''} text-xs flex flex-row gap-1 border rounded-full px-2 py-1 font-semibold text-gray-900 dark:text-gray-100 hover:shadow`}>
          <i className="ri-stop-circle-line text-red-700"></i>
          <span>Stop Test</span>
        </button>
      </div>

      <div className="w-1/2 flex flex-col items-center gap-1 leading-3">
        <small className="leading-3 text-gray-800 dark:text-gray-200">
          {isRunning ? "Time Left" : "Press any key or click to start"}
        </small>
        <span className="text-sm leading-3 font-medium text-gray-950 dark:text-gray-50">
          {formatTime(timeLeft)}
        </span>
      </div>

      <div className="w-1/4 flex flex-row justify-end gap-1">
        {!viewSideBySide && <button onClick={() => setViewSideBySide(!viewSideBySide)} className="text-xl hover:shadow hover:bg-gray-100 rounded border w-8 h-8">
          <i class="ri-layout-column-line text-gray-950"></i>
        </button>}
        {viewSideBySide && <button onClick={() => setViewSideBySide(!viewSideBySide)} className="text-xl hover:shadow hover:bg-gray-100 rounded border w-8 h-8">
          <i class="ri-layout-bottom-line text-gray-950"></i>
        </button>}
      </div>
    </div>

    {isFinished && <div className="flex flex-col gap-5 items-center p-4">
      <h2 className="text-2xl font-dmserif text-gray-950 dark:text-gray-50">Results</h2>

      {/* onClick={startTest}  */}
      <button onClick={home} className="flex flex-row items-center gap-1 mt-2 px-3 py-2 text-sm border rounded-lg text-gray-800 dark:bg-gray-100 font-medium hover:shadow">
        <i class="ri-reset-left-line"></i>
        <span>Retry</span>
      </button>

      <div className="flex flex-row flex-wrap justify-center gap-10">
        <Result labelText={"Total Words"} value={results?.totalTyped || "N/A"} uom="words" />
        <Result labelText={"Correct"} value={results?.correct || "N/A"} uom="words" />
        <Result labelText={"Incorrect"} value={results?.totalTyped || "N/A"} uom="words" />
        <Result labelText={"Accuracy"} value={results?.accuracy || "N/A"} uom="%" />
        <Result labelText={"Speed"} value={results?.wpm || "N/A"} uom="WPM" />
      </div>


      {results?.incorrectWords.length > 0 &&
        <div className="flex flex-col justify-center">
          <small className=" text-gray-700 dark:text-gray-400 text-center">Incorrect Words</small>
          <div className="flex flex-wrap gap-1 text-center justify-center">
            {results?.incorrectWords.map((w, i) => <small key={i} className="text-red-800 dark:text-red-500 bg-red-100 dark:bg-red-950 rounded px-1">{w}</small>)}
          </div>
        </div>
      }

      {/* {results?.missedWords.length>0 && <div className="mt-2"><p className="font-semibold">Missed Words:</p>
      //   <div className="flex flex-wrap gap-2">{results?.missedWords.map((w,i)=><span key={i} className="px-2 py-1 bg-yellow-200 rounded">{w}</span>)}</div>
      // </div>} */}
    </div>}

    {viewSideBySide ?
      <div className="flex-grow flex flex-col md:flex-row gap-4 p-2 overflow-hidden h-[70vh]">
        {/* Left: Text to type */}
        <div
          className={`scroll-smooth font-medium scrollbar-small text-${textSize} w-full md:w-1/2 h-1/2 md:h-full border dark:border-gray-600 p-4 rounded dark:bg-gray-800 text-gray-900 dark:text-gray-100 overflow-y-auto`}
          dangerouslySetInnerHTML={{ __html: getHighlightedText() }}
        />


        {/* Right: Typing box */}
        <div className="w-full md:w-1/2 h-1/2 md:h-full flex">
          <textarea
            value={input}
            onChange={handleInput}
            placeholder="Start typing..."
            spellCheck={false}
            className={`scrollbar-small bg-yellow-200 font-medium text-${textSize} h-full w-full border border-yellow-300 dark:border-yellow-800 rounded p-3 text-gray-900 placeholder-yellow-600 dark:placeholder-gray-400 dark:text-gray-100 dark:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-yellow-600 focus:border-transparent resize-none`}
          />
        </div>
      </div>
      :
      <div className="flex-grow flex flex-col gap-2 p-2 overflow-hidden h-[70vh]">
        {/* Left: Text to type */}
        <div
          className={`font-medium scrollbar-small text-${textSize} w-full h-5/6 border dark:border-gray-600 p-4 rounded dark:bg-gray-800 text-gray-900 dark:text-gray-100 overflow-y-auto`}
          dangerouslySetInnerHTML={{ __html: getHighlightedText() }}
        />

        {/* Right: Typing box */}
        <div className="w-full h-1/6 flex justify-center">
          <input
            value={input}
            onChange={handleInput}
            placeholder="Start typing..."
            spellCheck={false}
            className={`scrollbar-small bg-yellow-200 dark:bg-yellow-950 text-center font-medium text-${textSize} h-full w-full border border-yellow-300 dark:border-yellow-800 rounded p-3 text-gray-900 placeholder-yellow-600 dark:placeholder-gray-400 dark:text-gray-100 dark:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-yellow-600 focus:border-transparent`}
          />
        </div>
      </div>
    }
  </div>;
};

export default Practice;


export const Result = ({ labelText, value, uom }) => {
  return <div className="flex flex-col">
    <small className=" text-gray-700 dark:text-gray-400">{labelText}</small>
    <span className="font-medium text-indigo-950 dark:text-gray-300">{value || "N/A"} <span className="font-normal text-sm text-gray-800 dark:text-gray-200">{uom}</span></span>
  </div>
}